<template>
  <div class="sideCard">
    <div class="text-xs-center sub-header pt-4 pb-3">
      {{ $t('Total Inv Gen') }} : <span class="number--text">{{ totalInvGen }} kWh</span>
    </div>
    <ExpansionTree :items="expansionData" :active="activePanel"
      @panelSelection="(val) => panelSelectionHandler(...val)" />
  </div>
</template>

<script>
import _ from 'lodash'
import {
  EventBus
} from '@/services/event-bus'
import {
  mapGetters,
  mapMutations
} from 'vuex'

export default {
  components: {
    ExpansionTree: () => import('./Side/ExpansionTree')
  },
  props: ['blockData'],
  data() {
    return {
      graphLevel: 'room',
      selectedBlock: null,
      selectedRoom: null,
      expansionData: [],
      activePanel: []
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId']),
    totalInvGen() {
      const totalGen = this.blockData.reduce((old, curr) => {
        old += parseFloat(curr.gen)
        return old
      }, 0)
      return totalGen.toFixed(2)
    }
  },
  mounted() {
    this.expansionData = this.initialList()
    this.activePanel = this.initialActivePanel(this.expansionData)
  },
  methods: {
    initialList() {
      function recursiveFun(item, dp) {
        return item.map(el => {
          el['depth'] = dp
          if (el.children) {
            let incrementedDP = dp + 1
            recursiveFun(el.children, incrementedDP)
          }

          return el
        })
      }

      if (this.blockData.length) {
        let depth = 0
        const copyBlockData = _.cloneDeep(this.blockData)
        copyBlockData[0]['active'] = true
        return recursiveFun(copyBlockData, depth)
      }
    },
    panelSelectionHandler(value, index) {
      this.graphLevel = value.level
      if (value.level === 'block') {
        this.selectedBlock = value.id
        this.selectedRoom = null
      } else {
        this.selectedBlock = value.id.split('-')[0]
        this.selectedRoom = value.id.split('-')[1]
      }

      EventBus.$emit('change:level', value)
    },
    initialActivePanel(item) {
      const clonedItem = _.cloneDeep(item)
      return clonedItem.map((el, index) => {
        const active = {}
        active[el.id] = el.active ? el.active : false
        active['depth'] = el.depth
        active['children'] = el.children ? this.initialActivePanel(el.children) : null
        if (active[el.id]) {
          this.panelSelectionHandler(el, index)
        }
        return active
      })
    }
  },
  watch: {
    totalInvGen() {
      this.$emit('totalGen', this.totalInvGen);
    },
    blockData: {
      handler(value, oldValue) {
        if (!_.isEqual(value, oldValue)) {
          this.expansionData = this.initialList()
          this.activePanel = this.initialActivePanel(this.expansionData)
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .sideCard {
    height: 635px;
    width: 100%;
  }

  @media (max-width:960px) {
    .sideCard {
      height: 100%;
    }
    .hide {
      display: none;
    }
  }
</style>
